import {
  SettingOutlined,
  SwapOutlined,
  ThunderboltOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  HomeOutlined,
  BellOutlined,
  EditOutlined,
  UserOutlined,
} from '@ant-design/icons';
import {Badge, MenuProps} from 'antd';
import {Layout, Menu} from 'antd';
import styles from './Layout.module.css';
import React, {useEffect, useState} from 'react';
import {NavLink, useLocation} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from '../../common/hooks';
import SetupRoutes from '../CustomRoutes';
import ProfileAvatar from './ProfileAvatar';
import Notifications from '../notifications/Notifications';
import {notifications, setIsRead} from '../notifications/notificationsSlice';
import {batteriesList} from '../setup/battery/batteries/batteriesSlice';

const {Header, Sider, Content} = Layout;
type MenuItem = Required<MenuProps>['items'][number];

const EmplyoeeScreen = () => {
  const [collapsed, setCollapsed] = useState(true);
  const dispatch = useAppDispatch();

  const userPermissions = useAppSelector((state) => state.config.config);
  const state = useAppSelector((state) => state.auth);
  const read = useAppSelector((state) => state.notifications.is_read);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    dispatch(notifications({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group',
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }

  const items: MenuItem[] = [
    // getItem(<NavLink to={'/dashboard'}>Dashboard</NavLink>, 'dashboard', <HomeOutlined />),
    userPermissions.permissions.show_station_battery
      ? getItem(<NavLink to={'batteries'}>Batteries</NavLink>, 'batteries', <HomeOutlined />)
      : null,
    userPermissions.permissions.show_swap
      ? getItem(
          <NavLink to={'transactions'}>Transactions</NavLink>,
          'transactions',
          <SwapOutlined />,
        )
      : null,
    userPermissions.permissions.show_customer
      ? getItem(<NavLink to={'customers'}>Customers</NavLink>, 'customers', <UserOutlined />)
      : null,

    userPermissions.permissions.show_employee ||
    userPermissions.permissions.show_station ||
    userPermissions.permissions.show_battery ||
    userPermissions.permissions.show_charger ||
    userPermissions.permissions.show_rack ||
    userPermissions.permissions.show_vehicle
      ? getItem(
          'Setup',
          'sub1',
          <SettingOutlined />,

          [
            userPermissions.permissions.show_employee
              ? getItem(<NavLink to={'setup/employee'}>Emplyoee</NavLink>, 'employee')
              : null,

            userPermissions.permissions.show_station
              ? getItem(<NavLink to={'setup/station'}>Station</NavLink>, 'station')
              : null,

            userPermissions.permissions.show_battery
              ? getItem(<NavLink to={'setup/battery'}>Battery</NavLink>, 'battery')
              : null,

            userPermissions.permissions.show_charger
              ? getItem(<NavLink to={'setup/charger'}>Charger</NavLink>, 'charger')
              : null,

            userPermissions.permissions.show_rack
              ? getItem(<NavLink to={'setup/rack'}>Cabinet</NavLink>, 'rack')
              : null,

            userPermissions.permissions.show_vehicle
              ? getItem(<NavLink to={'setup/vehicle'}>Vehicle</NavLink>, 'vehicle')
              : null,
          ],
        )
      : null,

    userPermissions.is_admin || userPermissions.is_super_admin
      ? getItem(
          <NavLink to={'organisationconfig'}>Config</NavLink>,
          'organisationconfig',
          <EditOutlined />,
        )
      : null,
  ];

  const activeMenu = useLocation().pathname.split('/');

  return (
    <Layout style={{height: '100vh', maxHeight: '100vh'}}>
      <Sider
        theme='light'
        trigger={null}
        collapsible
        collapsed={collapsed}
        collapsedWidth='80px'
        width='200px'
        style={{
          overflowY: 'auto',
          height: '100%',
          scrollbarWidth: 'auto',
          transitionDuration: '.5s',
          borderRight: '1px solid #00000048',
          overflowX: 'hidden',
        }}
      >
        <div className={styles.logo}>
          {collapsed ? (
            <img
              style={{
                width: '30px',
              }}
              src='/short_logo.ico'
              alt='short_logo'
            />
          ) : (
            <img
              style={{
                width: '90%',
                transition: 'width 0.5s ease 0s',
              }}
              src='/ef_main.png'
              alt='logo'
            />
          )}
        </div>
        <Menu
          mode='inline'
          selectedKeys={[activeMenu.length > 2 ? activeMenu[2] : activeMenu[1]]}
          style={{
            backgroundColor: 'transparent',
            border: '0px',
            paddingBlock: '20px',
          }}
          items={items}
        />
      </Sider>
      <Layout
        className={styles.site_layout}
        //style={{marginLeft: `${collapsed ? '70px' : '200px'}`, transitionDuration: '.5s'}}
      >
        <Header className={styles.site_layout_background} style={{padding: '0 20px 0 0'}}>
          {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
            className: ` ${styles.trigger}`,
            onClick: () => setCollapsed(!collapsed),
          })}
          <p style={{margin: '0px', fontSize: '16px'}}> Hi, {state.user.details.name}</p>
          <h1 style={{margin: '0px'}}></h1>
          <div>
            <Badge dot={read}>
              <BellOutlined
                style={{fontSize: 20, cursor: 'pointer'}}
                onClick={() => {
                  dispatch(
                    notifications({filters: {mark_read: true, page_size: 10, page_number: 1}}),
                  )
                    .unwrap()
                    .then(() => {
                      setIsDrawerOpen(true);
                      dispatch(batteriesList({is_active: true}));
                      dispatch(setIsRead(false));
                    });
                }}
              />
            </Badge>
          </div>

          <ProfileAvatar />
        </Header>
        <Content className={styles.content}>
          <SetupRoutes />
        </Content>
      </Layout>

      <Notifications isOpen={isDrawerOpen} setIsOpen={setIsDrawerOpen} />
    </Layout>
  );
};

export default EmplyoeeScreen;
